"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactTooltip = require("react-tooltip");
const _1 = require(".");
const Copiable = ({ tooltipText, placement, copiableText, children }) => {
    const copyText = () => {
        const textarea = document.createTextNode('textarea');
        textarea.textContent = copiableText;
        document.body.appendChild(textarea);
        const range = document.createRange();
        range.selectNodeContents(textarea);
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(range);
        const copied = document.execCommand('copy');
        document.getSelection().removeAllRanges();
        document.body.removeChild(textarea);
        ReactTooltip.hide();
    };
    return (React.createElement("div", { style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        } },
        children,
        React.createElement("a", { "data-tip": "React-tooltip", onClick: copyText, onTouchStart: copyText },
            React.createElement(_1.ClipboardIcon, { fill: _1.turquoise })),
        React.createElement(ReactTooltip, { place: placement || 'bottom', type: "dark", effect: "solid" },
            React.createElement("span", { style: {
                    fontFamily: `"Source Sans Pro", sans-serif`,
                } }, tooltipText || 'Copy to clipboard'))));
};
exports.default = Copiable;
